import React from "react";
import {
  blackColor,
  blackShade21,
  greenColor7,
  greyColor42,
  lightGreen04,
  lightRedColor02,
  outOfStockColor,
  whiteColor,
  yellowShade03,
} from "../../../configs/styles/muiThemes";
import {
  Box,
  Button,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import HeaderInfoRow from "../Card/HeaderInfoRow";
import SyncProductInfoRowCard from "../Card/SyncProductInfoRowCard";
import SyncProblemIcon from "@mui/icons-material/SyncProblem";
import SyncIcon from "@mui/icons-material/Sync";

const SyncSkuTab = ({
  notSycedProducts,
  alreadySyncedSkus,
  invalidSkus,
  onSyncSku,
  onGoBack,
  handleDeleteSku,
  loader,
}) => {
  return (
    <Box p="15px 0 5px">
      {invalidSkus?.length > 0 || alreadySyncedSkus?.length > 0 ? (
        <Stack sx={styles.warningInfoBox}>
          {invalidSkus?.length > 0 && (
            <WarningInfoCard
              label="Invalid SKUs"
              value={`${invalidSkus?.length} SKU Ids: 
          ${invalidSkus?.map((skuId) => `${skuId}`)}`}
              color={outOfStockColor}
              bgcolor={lightRedColor02}
              icon={
                <SyncProblemIcon color="inherit" sx={{ fontSize: "19px" }} />
              }
            />
          )}

          {alreadySyncedSkus?.length > 0 && (
            <WarningInfoCard
              label="Already Synced SKUs"
              value={`${alreadySyncedSkus?.length} SKU Ids: 
          ${alreadySyncedSkus?.map((skuId) => `${skuId}`)}`}
              color={greenColor7}
              bgcolor={lightGreen04}
              icon={<SyncIcon color="inherit" sx={{ fontSize: "19px" }} />}
            />
          )}
        </Stack>
      ) : null}

      {notSycedProducts?.length > 0 && (
        <>
          <Typography
            fontSize={13}
            fontWeight={600}
            lineHeight="18px"
            color={blackColor}
          >
            New SKUs - {notSycedProducts?.length}
          </Typography>
          <Box mt={1.2}>
            <HeaderInfoRow tabValue={1} />

            <Box>
              {notSycedProducts?.map((productInfo, index) => {
                const info = productInfo?.itemTypeDTO || null;
                return (
                  <SyncProductInfoRowCard
                    key={`${info?.id}_${index}`}
                    index={index}
                    productImg={info?.imageUrl}
                    productName={info?.name}
                    skuCode={info?.skuCode}
                    tabValue={1}
                    onDelete={() => {
                      handleDeleteSku(index);
                    }}
                  />
                );
              })}
            </Box>

            {/* <Box display="flex" justifyContent="center" mt={3} gap={3}>
          <Button
            disableElevation
            variant="contained"
            sx={styles.backBtn}
            onClick={onGoBack}
          >
            BACK
          </Button>

          <Button
            disableElevation
            variant="contained"
            sx={styles.btn}
            onClick={onSyncSku}
            startIcon={
              loader ? <CircularProgress size={16} color="inherit" /> : null
            }
          >
            SYNC ALL SKUs
          </Button>
        </Box> */}
          </Box>
        </>
      )}
    </Box>
  );
};

export default SyncSkuTab;

const WarningInfoCard = ({ icon, color, bgcolor, label, value }) => {
  return (
    <Box sx={{ ...styles.warningCard, bgcolor: bgcolor }}>
      <Box sx={{ ...styles.warningCardIcon, color: color }}>{icon}</Box>

      <Typography
        fontSize={12}
        fontWeight={600}
        lineHeight="18px"
        color={color}
      >
        {label} - <span style={{ fontWeight: 500 }}>{value}</span>
      </Typography>
    </Box>
  );
};

const styles = {
  btn: {
    fontSize: 13,
    fontWeight: 600,
    color: blackColor,
    bgcolor: yellowShade03,
    border: `1px solid ${yellowShade03}`,
    p: "4px 30px 5px",
    "&:hover": {
      color: yellowShade03,
      bgcolor: whiteColor,
    },
  },

  backBtn: {
    fontSize: 12,
    fontWeight: 600,
    color: blackShade21,
    bgcolor: whiteColor,
    border: `1px solid ${blackShade21}`,
    p: "4px 30px 5px",
    "&:hover": {
      color: blackShade21,
      bgcolor: whiteColor,
    },
  },

  warningInfoBox: {
    alignItems: "flex-start",
    bgcolor: whiteColor,
    p: "12px 10px 2px",
    border: `1px solid ${greyColor42}`,
    borderRadius: "10px",
    mb: 2,
  },

  warningCard: {
    borderRadius: "5px",
    p: "3px 8px",
    display: "flex",
    alignItems: "center",
    gap: 1,
    mb: 1.3,
  },

  warningCardIcon: {
    bgcolor: whiteColor,
    width: "24px",
    height: "24px",
    borderRadius: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};
